// third party imports
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// internal rebet imports
import "./stylesReports.css";
import { SIDER_TABS } from "../../utils/Constants";
import AffiliatePanelInstance from "../../api/AffiliatePanelInstance";

// component imports
import RebetLoader from "../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import AppContext from "../../context/AppContext";
import { AppStrings } from "../../utils/constants/AppStrings";
import { usePageTitle } from "../CommonComponents/Layout/PageTitleContext";

// asset imports

const Reports = () => {
  usePageTitle(AppStrings.REPORTS);

  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );
  const { setActiveSidebarTab } = useContext(AppContext);


  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [expandedReport, setExpandedReport] = useState(null);
  const [reports, setReports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);


  const toggleExpand = (index) => {
    setExpandedReport(expandedReport === index ? null : index);
  };

  const getReports = async () => {
    setIsApiRunning(true);

    const params = {
      page: currentPage,
    };
    
    try {
      const response = await PrivateAdminPanelInstance?.get(
        API_ROUTES?.LIST_DM_REPORTS,
        params
      );
      const data = response?.data.data;
      setReports(data);
      setIsApiRunning(false);
    } catch (error) {
      setIsApiRunning(false);
      console.log("error reports", error);
    }
  };

  const closeReport = async (e, reporterId, messageId) => {
    e.stopPropagation();
    setErrorMessage("");
    setSuccessMessage("");

    let params = {
      user_id: reporterId,
      message_id: messageId,
    };

    try {
      await PrivateAdminPanelInstance?.patch(
        API_ROUTES?.CLOSE_DM_REPORT,
        params
      );

      setSuccessMessage("Report closed successfully.");
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      setErrorMessage(error.response.data.message);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleClickNext = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleClickPrev = () => {
    if (currentPage === 1) return;
    setCurrentPage((prev) => prev - 1);
  };

  useEffect(() => {
    getReports();
  }, [currentPage]);

    useEffect(() => {
      setActiveSidebarTab(SIDER_TABS.REPORTS, "Reports");
    }, [setActiveSidebarTab]);

  return (
    <>
      <div className="reports-body-container">
        <div className="reports-body">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                {errorMessage && (
                  <p className="error-message">{errorMessage}</p>
                )}
                {successMessage && (
                  <p className="success-message">{successMessage}</p>
                )}
              </div>
            </div>

            <div className="reports-container">
              {isApiRunning ? (
                <div className="loader-container">
                  <RebetLoader height={"100px"} width={"100px"} />
                </div>
              ) : (
                <>
                  {reports.length > 0 ? (
                    reports.map((report, index) => (
                      <div
                        key={index}
                        className={`report-card ${
                          expandedReport === index ? "expanded" : ""
                        }`}
                        onClick={() => toggleExpand(index)}
                      >
                        <div className="report-header">
                          <div>
                            <h3>
                              Report #{index + 1}
                              <span>
                                {expandedReport === index ? "-" : "+"}
                              </span>
                            </h3>
                            <div>
                              <p>{AppStrings.REPORTER}: {report.reporter.username}</p>
                              <p>
                                {AppStrings.REPORTED_USER}:{" "}
                                {report.reported_message.sender.username}
                              </p>
                              <p>{AppStrings.REPORTER_MESSAGE}: {report.report_desc}</p>
                              <p>{AppStrings.REASON}: {report.report_reason}</p>
                            </div>
                          </div>
                          <div className="report-actions">
                            <button
                              className="mute-btn"
                              onClick={(e) =>
                                closeReport(
                                  e,
                                  report.reporter.user_id,
                                  report.reported_message.message_id
                                )
                              }
                            >
                              {AppStrings.CLOSE_REPORT}
                            </button>
                          </div>
                        </div>
                        <div className="report-body">
                          <p className="reported-message">
                            "{report.reported_message.content}"
                          </p>
                        </div>
                        {expandedReport === index && (
                          <div className="report-details">
                            <h4>{AppStrings.CONTEXT_BEFORE}:</h4>
                            <ul>
                              {report.context_before.map((msg) => (
                                <li key={msg.message_id}>
                                  <span className="username">
                                    {msg.sender.username}:
                                  </span>{" "}
                                  "{msg.content}"
                                </li>
                              ))}
                            </ul>
                            <h4>{AppStrings.CONTEXT_AFTER}:</h4>
                            <ul>
                              {report.context_after.map((msg) => (
                                <li key={msg.message_id}>
                                  <span className="username">
                                    {msg.sender.username}:
                                  </span>{" "}
                                  "{msg.content}"
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="no-reports-container">
                          {AppStrings.NO_REPORTS_YET}
                    </div>
                  )}
                </>
              )}
            </div>
          </>
          {!isApiRunning && reports.length >= 10 && (
            <div className="table-controls-container">
              <p
                className={`prev-text ${currentPage === 1 ? "disabled" : ""}`}
                onClick={handleClickPrev}
              >
                {AppStrings.PREV}
              </p>
              <p className="current-page">{currentPage}</p>
              <p className="next-text" onClick={handleClickNext}>
                {AppStrings.NEXT}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Reports;
